/**
 * Máscaras e limites usados pelos fluxos de agenda do CRM (modal Agendar,
 * calendário e edição de evento externo).
 */

export const DATE_MASK = 'DD/MM/YYYY'
export const TIME_MASK = 'HH:mm'
export const DATETIME_MASK = `${DATE_MASK} ${TIME_MASK}`

// Offset -03:00 fixo por contrato do backend de agendamento.
export const SCHEDULE_PAYLOAD_MASK = 'YYYY-MM-DDTHH:mm:00-03:00'

export const LAST_MINUTE_OF_DAY = '23:59'
export const DEFAULT_EVENT_DURATION_HOURS = 1
